module.exports = __webpack_public_path__ + "media/src/ui/icons/iconOpenUrlNew-38d40f029d998079d9d508e49fa0a7e3.svg";